import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "asset-view-wrapper" }
const _hoisted_2 = { class: "assets-table-container" }
const _hoisted_3 = { class: "assets-grid-card" }
const _hoisted_4 = { class: "assets-grid-card__header" }
const _hoisted_5 = { class: "assets-grid-title" }
const _hoisted_6 = { class: "assets-grid-title__text" }
const _hoisted_7 = { class: "text-muted small" }
const _hoisted_8 = { class: "assets-grid-controls" }
const _hoisted_9 = ["title"]
const _hoisted_10 = ["title"]
const _hoisted_11 = { class: "assets-grid-card__body" }
const _hoisted_12 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center gap-2 mb-3"
}
const _hoisted_13 = {
  key: 1,
  class: "wp-loading"
}
const _hoisted_14 = { class: "wp-loading__text" }
const _hoisted_15 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SchemeEditor = _resolveComponent("SchemeEditor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "assets-grid-title__icon" }, [
              _createElementVNode("i", { class: "bi bi-diagram-3-fill" })
            ], -1)),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.scheme?.name || _ctx.$t('components.assetSchemes.editor.title')), 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.scheme?.group?.name || '-'), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              type: "button",
              class: "assets-toolbar-btn",
              title: _ctx.$t('common.back'),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'AssetSchemes' })))
            }, [
              _cache[3] || (_cache[3] = _createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.back')), 1)
            ], 8, _hoisted_9),
            _createElementVNode("button", {
              type: "button",
              class: "assets-toolbar-btn",
              title: _ctx.$t('components.assetSchemes.actions.edit'),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({ name: 'AssetSchemeEdit', params: { id: _ctx.id } })))
            }, [
              _cache[4] || (_cache[4] = _createElementVNode("i", { class: "bi bi-pencil" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.assetSchemes.actions.edit')), 1)
            ], 8, _hoisted_10)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _cache[5] || (_cache[5] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.errorMessage), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _cache[6] || (_cache[6] = _createElementVNode("span", {
                  class: "spinner-border wp-loading__spinner",
                  role: "status"
                }, null, -1)),
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('components.assetSchemes.loading')), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_SchemeEditor, {
                  "scheme-image": _ctx.schemeImage,
                  markers: _ctx.schemeMarkers,
                  assets: _ctx.assetsForGroup,
                  anchors: _ctx.anchors,
                  "read-only": true,
                  calibration: { widthM: _ctx.scheme?.widthM ?? null, heightM: _ctx.scheme?.heightM ?? null }
                }, null, 8, ["scheme-image", "markers", "assets", "anchors", "calibration"])
              ]))
        ])
      ])
    ])
  ]))
}